<!-- eslint-disable vue/no-dupe-keys -->
<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="55%"
    @close="dialogClose"
    top="0.5vh"
    modal-append-to-body
  >
    <div class="retention_money">
      <div>
        <el-descriptions class="margin-top" :column="2" border>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-wallet"></i>
              质保金
            </template>
            <el-input
              type="text"
              size="small"
              style="max-width: 100px; margin-right: 8px"
              :disabled="modify"
              ref="retentionMoneyRefs"
              v-model="retentionMoney"
              @input="validateRetentionMoney"
              clearable
            ></el-input>
            <el-button
              v-if="
                authorization(
                  '/home-admin/routineManage/user-list/deposit-manage/edit'
                )
              "
              type="text"
              @click="upDataMoney"
              >{{ modify ? "修改" : "保存" }}</el-button
            >
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-s-finance"></i>
              缴纳金额
            </template>
            {{ paymentAmountTotal }}
          </el-descriptions-item>
        </el-descriptions>
        <div class="remark">
          <div>
            <span style="margin-right: 5px">备注</span>
            <el-button
              type="text"
              v-if="
                authorization(
                  '/home-admin/routineManage/user-list/deposit-manage/edit'
                )
              "
              @click="updataRemark"
              >{{ remarkModify ? "修改" : "保存" }}</el-button
            >
          </div>
          <el-input
            type="textarea"
            ref="remarkRefs"
            clearable
            :disabled="remarkModify"
            rows="3"
            v-model="remark"
          ></el-input>
        </div>
      </div>
      <div>
        <p>支付抵扣缴纳记录</p>
        <el-table
          :data="paymentRecord"
          stripe
          border
          size="small"
          :header-cell-style="{
            'background-color': '#84aace4a',
            color: '#343333',
            'text-align': 'center',
          }"
          :cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column
            label="结算单名称"
            prop="settlementBatchName"
          ></el-table-column>
          <el-table-column
            label="支付费用"
            prop="paymentAmount"
          ></el-table-column>
          <el-table-column
            label="支付备注"
            prop="remarks"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="付款时间"
            prop="paymentTime"
          ></el-table-column>
          <el-table-column label="操作时间" prop="updateTime"></el-table-column>
          <el-table-column label="操作人" prop="updatedByStr"></el-table-column>
        </el-table>
      </div>
      <div>
        <p>结算账单中-正负激励-质保金抵扣缴纳记录</p>
        <el-table
          :data="settlementIncentiveRecords"
          stripe
          border
          size="small"
          :header-cell-style="{
            'background-color': '#84aace4a',
            color: '#343333',
            'text-align': 'center',
          }"
          :cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column
            label="结算单名称"
            prop="settlementBatchName"
          ></el-table-column>
          <el-table-column label="质保金额" prop="amount"></el-table-column>
          <el-table-column
            label="质保备注"
            prop="remarks"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="结算时间"
            prop="paymentTime"
          ></el-table-column>
          <el-table-column
            label="结算单归属师傅"
            prop="settlementResponsibleUserIdStr"
          ></el-table-column>
          <el-table-column
            label="质保操作时间"
            prop="updateTime"
          ></el-table-column>
          <el-table-column
            label="质保操作人"
            prop="updatedByStr"
          ></el-table-column>
        </el-table>
      </div>
       <!-- 手动缴纳记录区域 -->
       <div style="margin-bottom: 20px;">
         <div>
           <span style="margin-right: 5px">手动缴纳记录</span>
           <el-button
             @click="handleRow()"
             type="text"
             v-if="
               authorization(
                 '/home-admin/routineManage/user-list/deposit-manage/add'
               )
             "
             >新增</el-button
           >
         </div>
         <el-table
           :data="manualPaymentRecord"
           stripe
           border
           size="small"
           :header-cell-style="{
             'background-color': '#84aace4a',
             color: '#343333',
             'text-align': 'center',
           }"
           :cell-style="{ 'text-align': 'center' }"
         >
           <el-table-column label="序号" type="index" width="60"></el-table-column>
           <el-table-column label="支付金额" prop="amount"></el-table-column>
           <el-table-column
             label="支付时间"
             width="130"
             prop="paymentTime"
             :formatter="formatTimeToMinute"
           ></el-table-column>
           <el-table-column prop="attachmentIds" label="附件">
             <template slot-scope="scope">
               <span
                 v-if="
                   scope.row.attachmentIds && scope.row.attachmentIds.length > 0
                 "
               >
                 <el-button
                   type="text"
                   size="small"
                   @click="seeFileList(scope.row.attachmentIds.split(','))"
                   >{{ scope.row.attachmentIds.split(",").length }}</el-button
                 >
               </span>
             </template>
           </el-table-column>
           <el-table-column
             label="支付备注"
             prop="remarks"
             show-overflow-tooltip
           ></el-table-column>
           <el-table-column label="操作时间" prop="updateTime" width="130" :formatter="formatTimeToMinute"></el-table-column>
           <el-table-column label="操作人" prop="updatedByStr"></el-table-column>
           <el-table-column label="操作" width="130px" fixed="right">
             <template slot-scope="scope">
               <el-tooltip effect="dark" content="编辑" placement="top-end">
                 <el-button
                   content="编辑"
                   type="success"
                   icon="el-icon-edit"
                   circle
                   size="mini"
                   v-if="
                     authorization(
                       '/home-admin/routineManage/user-list/deposit-manage/edit'
                     )
                   "
                   @click="handleRow(scope.row)"
                 ></el-button>
               </el-tooltip>
               <el-tooltip
                 effect="dark"
                 content="删除"
                 placement="top-end"
                 v-if="
                   authorization(
                     '/home-admin/routineManage/user-list/deposit-manage/del'
                   )
                 "
               >
                 <el-popconfirm
                   title="确认删除吗？"
                   @confirm="deleteData(scope.row)"
                 >
                   <el-button
                     content="删除"
                     style="margin-left: 5px"
                     slot="reference"
                     type="danger"
                     icon="el-icon-delete"
                     circle
                     size="mini"
                   ></el-button>
                 </el-popconfirm>
               </el-tooltip>
             </template>
           </el-table-column>
         </el-table>
       </div>
       
       <!-- 手动扣减记录区域 -->
       <div>
         <div>
           <span style="margin-right: 5px">手动扣减记录</span>
           <el-button
             @click="openDeductionDialog()"
             type="text"
             v-if="
               authorization(
                 '/home-admin/routineManage/user-list/deposit-manage/add'
               )
             "
             >新增</el-button
           >
         </div>
         <el-table
           :data="manualDeductionRecord"
           stripe
           border
           size="small"
           :header-cell-style="{
             'background-color': '#84aace4a',
             color: '#343333',
             'text-align': 'center',
           }"
           :cell-style="{ 'text-align': 'center' }"
         >
           <el-table-column label="序号" type="index" width="60"></el-table-column>
           <el-table-column label="扣减金额" prop="amount"></el-table-column>
           <el-table-column label="扣减时间" width="130" prop="paymentTime" :formatter="formatTimeToMinute"></el-table-column>
           <el-table-column prop="attachmentIds" label="附件">
             <template slot-scope="scope">
               <span
                 v-if="
                   scope.row.attachmentIds && scope.row.attachmentIds.length > 0
                 "
               >
                 <el-button
                   type="text"
                   size="small"
                   @click="seeFileList(scope.row.attachmentIds.split(','))"
                   >{{ scope.row.attachmentIds.split(",").length }}</el-button
                 >
               </span>
             </template>
           </el-table-column>
           <el-table-column
             label="扣减备注"
             prop="remarks"
             show-overflow-tooltip
           ></el-table-column>
           <el-table-column label="操作时间" width="130" prop="updateTime" :formatter="formatTimeToMinute"></el-table-column>
           <el-table-column label="操作人" prop="updatedByStr"></el-table-column>
           <el-table-column label="操作" width="130px" fixed="right">
             <template slot-scope="scope">
               <el-tooltip effect="dark" content="编辑" placement="top-end">
                 <el-button
                   content="编辑"
                   type="success"
                   icon="el-icon-edit"
                   circle
                   size="mini"
                   v-if="
                     authorization(
                       '/home-admin/routineManage/user-list/deposit-manage/edit'
                     )
                   "
                   @click="handleDeductionRow(scope.row)"
                 ></el-button>
               </el-tooltip>
               <el-tooltip
                 effect="dark"
                 content="删除"
                 placement="top-end"
                 v-if="
                   authorization(
                     '/home-admin/routineManage/user-list/deposit-manage/del'
                   )
                 "
               >
                 <el-popconfirm
                   title="确认删除吗？"
                   @confirm="deleteDeductionData(scope.row)"
                 >
                   <el-button
                     content="删除"
                     style="margin-left: 5px"
                     slot="reference"
                     type="danger"
                     icon="el-icon-delete"
                     circle
                     size="mini"
                   ></el-button>
                 </el-popconfirm>
               </el-tooltip>
             </template>
           </el-table-column>
         </el-table>
       </div>
    </div>
    <!-- 手动添加缴纳记录 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogFormShow"
      width="700px"
      :close-on-click-modal="false"
      append-to-body
      @close="closeDialog"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="from"
        label-width="160px"
        size="small"
        style="width: 600px"
      >
        <el-form-item label="金额:" prop="amount">
          <el-input
            v-model="form.amount"
            maxlength="10"
            placeholder="请输入金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="支付时间" prop="paymentTime">
          <el-date-picker
            style="width: 100%"
            v-model="form.paymentTime"
            type="datetime"
            placeholder="选择支付时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注:" prop="remarks">
          <el-input
            type="textarea"
            placeholder="请输入备注"
            maxlength="500"
            v-model="form.remarks"
          ></el-input>
        </el-form-item>
        <el-form-item label="附件:">
          <UpLoad
            :fileSize="100"
            ref="uploadRefs"
            :limit="100"
            @remove="removeFile"
            @uploadSuccess="handleUploadSuccess"
          ></UpLoad>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" size="small">取 消</el-button>
        <el-button type="primary" @click="submitPaymentRecord" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    
    <!-- 手动添加扣减记录 -->
    <el-dialog
      :title="deductionTitle"
      :visible.sync="dialogDeductionShow"
      width="700px"
      :close-on-click-modal="false"
      append-to-body
      @close="closeDeductionDialog"
    >
      <el-form
        :model="deductionForm"
        :rules="deductionRules"
        ref="deductionForm"
        label-width="160px"
        size="small"
        style="width: 600px"
      >
        <el-form-item label="金额:" prop="amount">
          <el-input
            v-model="deductionForm.amount"
            maxlength="10"
            placeholder="请输入扣减金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="扣减时间" prop="paymentTime">
          <el-date-picker
            style="width: 100%"
            v-model="deductionForm.paymentTime"
            type="datetime"
            placeholder="选择扣减时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注:" prop="remarks">
          <el-input
            type="textarea"
            placeholder="请输入备注"
            maxlength="500"
            v-model="deductionForm.remarks"
          ></el-input>
        </el-form-item>
        <el-form-item label="附件:">
          <UpLoad
            :fileSize="100"
            ref="deductionUploadRefs"
            :limit="100"
            @remove="removeDeductionFile"
            @uploadSuccess="handleDeductionUploadSuccess"
          ></UpLoad>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDeductionDialog" size="small">取 消</el-button>
        <el-button type="primary" @click="submitDeductionRecord" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    
    <!-- 文件列表 -->
    <FileList ref="fileListRefs"></FileList>
  </el-dialog>
</template>

<script>
import { authorization } from "../../../authorization/authorization";
import FileList from "@/components/FileList";
import UpLoad from "@/components/UpLoad";
import Big from "big.js";
export default {
  props: [],
  components: {
    UpLoad,
    FileList,
  },
  data() {
    return {
      dialogVisible: false,
      dialogFormShow: false,
      dialogDeductionShow: false,
      dialogTitle: "质保金管理",
      masterName: "",
      title: "手动缴纳记录",
      deductionTitle: "手动扣减记录",
      retentionMoney: "",
      modify: true,
      remarkModify: true,
      remark: "",
      paymentAmount: "",
      paymentRecord: [],
      id: "",
       settlementIncentiveRecords: [],
       manualPaymentRecord: [],
       manualDeductionRecord: [],
      form: {
        paymentTime: "",
        amount: "",
        remarks: "",
        userId: "",
        attachmentIds: [],
      },
      rules: {
        paymentTime: [
          { required: true, message: "请选择支付时间", trigger: "change" },
        ],
        amount: [
          { required: true, message: "请输入金额", trigger: "blur" },
          {
            pattern: /^([1-9]\d{0,8}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
            message: "请输入正确的金额",
            trigger: "blur",
          },
        ],
      },
      // 扣减记录表单数据
      deductionForm: {
        paymentTime: "",
        amount: "",
        remarks: "",
        userId: "",
        attachmentIds: [],
        type: 2, // 记录类型：2表示扣减记录
      },
      // 扣减记录验证规则
      deductionRules: {
        paymentTime: [
          { required: true, message: "请选择扣减时间", trigger: "change" },
        ],
        amount: [
          { required: true, message: "请输入扣减金额", trigger: "blur" },
          {
            pattern: /^([1-9]\d{0,8}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
            message: "请输入正确的金额",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    paymentAmountTotal() {
      // 结算账单中正负激励质保金抵扣缴纳记录
      const amount = this.settlementIncentiveRecords.reduce((pre, cur) => {
        return pre.plus(new Big(cur.amount || 0));
      }, new Big(0));
      
      // 手动缴纳记录
      const amount2 = this.manualPaymentRecord.reduce((pre, cur) => {
        return pre.plus(new Big(cur.amount || 0));
      }, new Big(0));
      
      // 手动扣减记录（需要减去）
      const deductionAmount = this.manualDeductionRecord.reduce((pre, cur) => {
        return pre.plus(new Big(cur.amount || 0));
      }, new Big(0));

      return new Big(this.paymentAmount || 0)
        .plus(amount)
        .plus(amount2)
        .minus(deductionAmount)  // 减去扣减记录
        .toString();
    },
  },
  methods: {
    open(userId, masterName = "") {
      this.userId = userId;
      Object.assign(this.$data, this.$options.data());
      this.masterName = masterName;
      this.dialogTitle = masterName ? `质保金管理（${masterName}）` : "质保金管理";
      this.dialogVisible = true;
      this.getPageData();
    },
    seeFileList(ids) {
      this.$refs.fileListRefs.open(ids);
    },
    authorization,
    dialogClose() {
      this.$emit("depositManageClose");
    },
    closeDialog() {
      this.dialogFormShow = false;
      this.$refs.uploadRefs.fileList = [];
    },
    getPageData() {
      this.axios({
        url: "/v1/web/user-info/get-warranty-amount",
        method: "get",
        params: {
          userId: this.userId,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.id = res.data.data.id;
          this.retentionMoney = res.data.data.warrantyAmount; // 质保金
          this.remark = res.data.data.warrantyRemark; // 备注
          this.paymentAmount = res.data.data.paymentAmount; // 缴纳金额
          this.paymentRecord = res.data.data.paymentRecord; // 缴纳记录
        } else {
          this.$message.error(res.data.message);
        }
      });
      // 获取质保金账单抵扣记录
      this.axios({
        url: "/v1/web/user-info/listSettlementIncentive",
        method: "get",
        params: {
          userId: this.userId,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.settlementIncentiveRecords = res.data.data; // 缴纳记录
        } else {
          this.$message.error(res.data.message);
        }
      });

      this.listManualData();
    },
     listManualData() {
       // 获取手动质保金缴纳记录 (type: 1)
       this.axios({
         url: "/v1/web/manual-warranty-fund/list",
         method: "post",
         data: {
           queryInfoParams: {
             userId: this.userId,
             type: 1, // 缴纳记录
           },
           page: 1,
           size: 2000,
         },
       }).then((res) => {
         if (res.data.code == 200) {
           this.manualPaymentRecord = res.data.data.list; // 缴纳记录
         } else {
           this.$message.error(res.data.message);
         }
       });
       
       // 获取手动质保金扣减记录 (type: 2)
       this.axios({
         url: "/v1/web/manual-warranty-fund/list",
         method: "post",
         data: {
           queryInfoParams: {
             userId: this.userId,
             type: 2, // 扣减记录
           },
           page: 1,
           size: 2000,
         },
       }).then((res) => {
         if (res.data.code == 200) {
           this.manualDeductionRecord = res.data.data.list; // 扣减记录
         } else {
           this.$message.error(res.data.message);
         }
       });
     },
    upDataMoney() {
      this.modify = !this.modify;
      if (!this.modify) {
        this.$nextTick(() => {
          this.$refs.retentionMoneyRefs.focus();
        });
      } else {
        this.updata();
      }
    },
    updataRemark() {
      this.remarkModify = !this.remarkModify;
      if (!this.remarkModify) {
        this.$nextTick(() => {
          this.$refs.remarkRefs.focus();
        });
      } else {
        this.updata();
      }
    },
    updata() {
      this.axios({
        url: "/v1/web/user-info/update-warranty-amount",
        method: "put",
        data: {
          id: this.id,
          paymentAmount: this.paymentAmount,
          warrantyAmount: this.retentionMoney,
          warrantyRemark: this.remark,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message.success(res.data.message);
          // this.dialogVisible = false
          // this.dialogClose()
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    validateRetentionMoney(value) {
      // 允许输入空值或符合规则的数字
      const regex = /^\d{0,9}(\.\d{0,2})?$/;
      if (regex.test(value) || value === "") {
        this.retentionMoney = value;
      } else {
        this.$message.warning("请输入正确的金额");
        this.retentionMoney = "";
      }
    },
    submitPaymentRecord() {
      this.$refs.from.validate((valid) => {
        if (!valid) {
          return;
        }
        const url = this.form.id
          ? "/v1/web/manual-warranty-fund/edit/" + this.form.id
          : "/v1/web/manual-warranty-fund/add";

        this.axios({
          url,
          method: "post",
          data: {
            ...this.form,
            attachmentIds: this.form.attachmentIds.join(","),
            type: 1, // 确保记录类型为缴纳记录
          },
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.message);
              this.dialogFormShow = false;
              this.$refs.uploadRefs.fileList = [];
              this.getPageData();
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch((error) => {
            this.$message.error("请求失败，请稍后再试");
          });
      });
    },
    handleUploadSuccess(resData) {
      this.form.attachmentIds.push(resData);
    },
    removeFile(file, fileList) {
      this.form.attachmentIds = fileList.map((item) => item.uid);
    },
    
    // 扣减记录相关方法
    openDeductionDialog() {
      this.deductionTitle = "新增手动扣减记录";
      this.deductionForm = {
        paymentTime: "",
        amount: "",
        remarks: "",
        userId: this.userId,
        attachmentIds: [],
        type: 2, // 记录类型：2表示扣减记录
      };
      this.$nextTick(() => {
        if (this.$refs.deductionUploadRefs) {
          this.$refs.deductionUploadRefs.fileList = [];
        }
      });
      this.dialogDeductionShow = true;
    },
    closeDeductionDialog() {
      this.dialogDeductionShow = false;
      this.$refs.deductionForm.resetFields();
      this.deductionForm.attachmentIds = [];
      this.$refs.deductionUploadRefs.fileList = [];
    },
    submitDeductionRecord() {
      this.$refs.deductionForm.validate((valid) => {
        if (!valid) {
          return;
        }
        const url = this.deductionForm.id
          ? "/v1/web/manual-warranty-fund/edit/" + this.deductionForm.id
          : "/v1/web/manual-warranty-fund/add";

        this.axios({
          url,
          method: "post",
          data: {
            ...this.deductionForm,
            attachmentIds: this.deductionForm.attachmentIds.join(","),
            type: 2, // 确保记录类型为扣减记录
          },
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.message);
              this.dialogDeductionShow = false;
              this.$refs.deductionUploadRefs.fileList = [];
              this.getPageData();
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch((error) => {
            this.$message.error("请求失败，请稍后再试");
          });
      });
    },
    handleDeductionUploadSuccess(resData) {
      this.deductionForm.attachmentIds.push(resData);
    },
     removeDeductionFile(file, fileList) {
       this.deductionForm.attachmentIds = fileList.map((item) => item.uid);
     },
     handleDeductionRow(data) {
       if (data) {
         this.deductionForm = {
           ...data,
           attachmentIds: data.attachmentIds
             ? data.attachmentIds.split(",")
             : [],
         };
         if (this.deductionForm.attachmentIds.length > 0) {
           this.$nextTick(() => {
             this.getDeductionFileList(this.deductionForm.attachmentIds);
           });
         }
         this.deductionTitle = "编辑手动扣减记录";
       } else {
         this.deductionTitle = "新增手动扣减记录";
         this.deductionForm = {
           amount: "",
           remarks: "",
           paymentTime: "",
           userId: this.userId,
           attachmentIds: [],
           type: 2, // 记录类型：2表示扣减记录
         };
         this.$nextTick(() => {
           if (this.$refs.deductionUploadRefs) {
             this.$refs.deductionUploadRefs.fileList = [];
           }
         });
       }
       this.dialogDeductionShow = true;
     },
     deleteDeductionData(data) {
       this.axios({
         url: `/v1/web/manual-warranty-fund/del/${data.id}`,
         method: "DELETE",
       }).then((res) => {
         if (res.data.code === 200) {
           this.$message.success("删除成功");
           this.listManualData();
         } else {
           this.$message.error(res.data.message);
         }
       });
     },
     getDeductionFileList(val) {
       this.axios({
         url: "/attachment/list",
         method: "POST",
         data: {
           ids: val.join(","),
         },
       }).then((res) => {
         if (res.data.data && res.data.data.length > 0) {
           const fileList = res.data.data.map((item) => {
             return {
               name: item.fileName,
               url: item.fileUrl,
               uid: item.id,
             };
           });
           this.$refs.deductionUploadRefs.fileList = [...fileList];
         }
       });
     },
    handleRow(data) {
      if (data) {
        this.form = {
          ...data,
          attachmentIds: data.attachmentIds
            ? data.attachmentIds.split(",")
            : [],
        };
        if (this.form.attachmentIds.length > 0) {
          this.$nextTick(() => {
            this.getFileList(this.form.attachmentIds);
          });
        }
        // this.currentData = data;
        this.title = "编辑手动缴纳记录";
      } else {
        this.title = "新增手动缴纳记录";
        this.form = {
          amount: "",
          remarks: "",
          paymentTime: "",
          userId: this.userId,
          attachmentIds: [],
          type: 1, // 记录类型：1表示缴纳记录
        };
        this.$nextTick(() => {
          if (this.$refs.uploadRefs) {
            this.$refs.uploadRefs.fileList = [];
          }
        });
      }
      this.dialogFormShow = true;
    },
    deleteData(data) {
      this.axios({
        url: `/v1/web/manual-warranty-fund/del/${data.id}`,
        method: "DELETE",
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("删除成功");
          this.listManualData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
     getFileList(val) {
       this.axios({
         url: "/attachment/list",
         method: "POST",
         data: {
           ids: val.join(","),
         },
       }).then((res) => {
         if (res.data.data && res.data.data.length > 0) {
           const fileList = res.data.data.map((item) => {
             return {
               name: item.fileName,
               url: item.fileUrl,
               uid: item.id,
             };
           });
           this.$refs.uploadRefs.fileList = [...fileList];
         }
       });
     },
     // 格式化时间到分钟
     formatTimeToMinute(row, column, cellValue) {
       if (!cellValue) return '-';
       // 截取到分钟，去掉秒数
       return cellValue.substring(0, 16);
     },
  },
};
</script>

<style scoped>
.retention_money {
  padding: 20px;
  background-color: rgb(238, 238, 238);
  max-height: 82vh;
  overflow-y: auto;
}
.money {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
}
::v-deep .el-form--label-top .el-form-item__label {
  padding: 0;
}

::v-deep .el-dialog {
  margin-bottom: 0px !important;
}

::v-deep .el-dialog__body {
  padding-top: 5px;
}
</style>
